"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.text = exports.tertiary = exports.success = exports.shadow = exports.shade = exports.secondary = exports.primary = exports.padding = exports.mediaQueries = exports.margin = exports.iconSize = exports.iconColor = exports.fontSize = exports.font = exports.error = exports.disabled = exports.colors = exports.breakpoint = exports.border = exports.background = void 0;
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
const colors = exports.colors = {
  persianBlue: '#204cc7',
  lsBlue: '#2962ff',
  Periwinkle: '#C5D4FF',
  zircon: '#f4f7ff',
  teal: '#009488',
  persianGreen: '#00a699',
  monteCarlo: '#87D6C5',
  dew: '#f4fffe',
  supernova: '#ffcc00',
  coralPink: '#ff585b',
  roseWhite: '#fff9f9',
  carolinaBlue: '#94b1ff',
  veryLightBlueThree: '#dce5ff',
  // grey & black shades from darkest to lightest
  firefly: '#0b1a25',
  outerSpace: '#2f393e',
  tundora: '#4a4a4a',
  emperor: '#555555',
  shuttleGrey: '#5c646a',
  nevada: '#6D7478',
  dustyGrey: '#9b9b9b',
  silver: '#bbbbbb',
  alto: '#d1d1d1',
  gallery: '#ececec',
  porcelain: '#f4f5f6',
  athensGrey: '#f8f9fb',
  white: '#ffffff'
};
const primary = exports.primary = {
  normal: colors.lsBlue,
  primary100: colors.zircon,
  primary200: colors.Periwinkle,
  primary300: colors.lsBlue,
  primary400: colors.persianBlue
};
const secondary = exports.secondary = {
  normal: colors.persianGreen,
  secondary100: colors.dew,
  secondary200: colors.monteCarlo,
  secondary300: colors.persianGreen,
  secondary400: colors.teal
};
const tertiary = exports.tertiary = {
  tertiary100: colors.supernova
};
const shade = exports.shade = {
  shade100: colors.white,
  shade200: colors.athensGrey,
  shade300: colors.porcelain,
  shade400: colors.gallery,
  shade500: colors.alto,
  shade600: colors.silver,
  shade700: colors.dustyGrey,
  shade800: colors.nevada,
  shade900: colors.shuttleGrey,
  shade1000: colors.emperor,
  shade1100: colors.tundora,
  shade1200: colors.outerSpace,
  shade1300: colors.firefly
};
const background = exports.background = {
  normal: colors.porcelain,
  background100: colors.white,
  background200: colors.athensGrey,
  background300: colors.porcelain,
  background400: colors.gallery,
  background500: colors.alto,
  background600: colors.shuttleGrey,
  background700: colors.outerSpace,
  background800: colors.firefly
};
const text = exports.text = {
  normal: colors.tundora,
  disabled: colors.silver,
  text100: colors.white,
  text200: colors.silver,
  text300: colors.dustyGrey,
  text400: colors.nevada,
  text500: colors.emperor,
  text600: colors.tundora,
  text700: colors.lsBlue
};
const error = exports.error = {
  normal: colors.coralPink,
  error100: colors.roseWhite,
  error200: colors.coralPink
};
const success = exports.success = {
  success100: colors.dew,
  success200: colors.persianGreen
};
const disabled = exports.disabled = {
  disabled100: colors.silver,
  disabled200: colors.nevada
};
const border = exports.border = {
  normal: colors.alto,
  border100: colors.white,
  border200: colors.porcelain,
  border300: colors.gallery,
  border400: colors.alto,
  border500: colors.tundora,
  border600: colors.veryLightBlueThree,
  border700: colors.carolinaBlue
};
const font = exports.font = {
  circular: 'Circular',
  roboto: 'Roboto',
  localsearch: 'Localsearch-Icon-Font',
  materialDesign: 'Material-Design-Iconic-Font'
};
const fontSize = exports.fontSize = {
  xxsmall: '9px',
  xsmall: '11px',
  small: '14px',
  normal: '16px',
  medium: '18px',
  large: '26px',
  xlarge: '30px',
  xxlarge: '50px'
};
const padding = exports.padding = {
  xsmall: '4px',
  small: '8px',
  normal: '16px',
  medium: '24px',
  large: '32px',
  xlarge: '44px',
  xxlarge: '88px'
};
const margin = exports.margin = {
  xsmall: '4px',
  small: '8px',
  normal: '16px',
  medium: '24px',
  large: '32px',
  xlarge: '44px',
  xxlarge: '88px'
};
const iconSize = exports.iconSize = {
  small: '20px',
  normal: '25px',
  medium: '35px',
  large: '45px',
  xlarge: '55px',
  xxlarge: '65px'
};
const iconColor = exports.iconColor = {
  primary: colors.lsBlue,
  secondary: colors.persianGreen,
  normal: colors.tundora,
  light: colors.white,
  highlightLight: colors.veryLightBlueThree,
  highlightNormal: colors.carolinaBlue,
  dark: colors.tundora,
  disabled: colors.silver,
  disabledLight: colors.nevada
};
const shadow = exports.shadow = {
  popup: '0 1px 20px 0 rgba(0, 0, 0, 0.2)',
  title: '0 1px 2px 0 rgba(0, 0, 0, 0.38)',
  button: '1px 1px 2px 0 rgba(125, 125, 125, 0.6)'
};
const breakpoint = exports.breakpoint = {
  tablet: 550,
  desktop: 1024
};
const mediaQueries = exports.mediaQueries = {
  mobile: `(max-width: ${breakpoint.tablet - 1}px)`,
  tablet: `(min-width: ${breakpoint.tablet}px) and (max-width: ${breakpoint.desktop - 1}px)`,
  desktop: `(min-width: ${breakpoint.desktop}px)`
};
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(colors, "colors", "/Users/jake.clayton/frontend/ls-common-client/src/themes/default.js");
  reactHotLoader.register(primary, "primary", "/Users/jake.clayton/frontend/ls-common-client/src/themes/default.js");
  reactHotLoader.register(secondary, "secondary", "/Users/jake.clayton/frontend/ls-common-client/src/themes/default.js");
  reactHotLoader.register(tertiary, "tertiary", "/Users/jake.clayton/frontend/ls-common-client/src/themes/default.js");
  reactHotLoader.register(shade, "shade", "/Users/jake.clayton/frontend/ls-common-client/src/themes/default.js");
  reactHotLoader.register(background, "background", "/Users/jake.clayton/frontend/ls-common-client/src/themes/default.js");
  reactHotLoader.register(text, "text", "/Users/jake.clayton/frontend/ls-common-client/src/themes/default.js");
  reactHotLoader.register(error, "error", "/Users/jake.clayton/frontend/ls-common-client/src/themes/default.js");
  reactHotLoader.register(success, "success", "/Users/jake.clayton/frontend/ls-common-client/src/themes/default.js");
  reactHotLoader.register(disabled, "disabled", "/Users/jake.clayton/frontend/ls-common-client/src/themes/default.js");
  reactHotLoader.register(border, "border", "/Users/jake.clayton/frontend/ls-common-client/src/themes/default.js");
  reactHotLoader.register(font, "font", "/Users/jake.clayton/frontend/ls-common-client/src/themes/default.js");
  reactHotLoader.register(fontSize, "fontSize", "/Users/jake.clayton/frontend/ls-common-client/src/themes/default.js");
  reactHotLoader.register(padding, "padding", "/Users/jake.clayton/frontend/ls-common-client/src/themes/default.js");
  reactHotLoader.register(margin, "margin", "/Users/jake.clayton/frontend/ls-common-client/src/themes/default.js");
  reactHotLoader.register(iconSize, "iconSize", "/Users/jake.clayton/frontend/ls-common-client/src/themes/default.js");
  reactHotLoader.register(iconColor, "iconColor", "/Users/jake.clayton/frontend/ls-common-client/src/themes/default.js");
  reactHotLoader.register(shadow, "shadow", "/Users/jake.clayton/frontend/ls-common-client/src/themes/default.js");
  reactHotLoader.register(breakpoint, "breakpoint", "/Users/jake.clayton/frontend/ls-common-client/src/themes/default.js");
  reactHotLoader.register(mediaQueries, "mediaQueries", "/Users/jake.clayton/frontend/ls-common-client/src/themes/default.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();